import appDispatchers from "../../views/appSettings/dispatchers.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "dispatchers";
  const params = ["page", "limit", "date", "created_at", "category", "city"];

  $stateProvider.state("dispatchers", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appDispatchers,
      },
    },
    reloadOnSearch: false,
    data: { title: "Dispatchers" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/dispatchers/dispatchers.urls.js